import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SetSignatureRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SetSignatureResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const setSignature = (request: SetSignatureRequest, options?: CashRequestOptions) =>
  post<SetSignatureRequest, SetSignatureResponse>('/2.0/cash/set-signature', request, {
    ...options,
    rejectOnError: true,
  })
